import { EsquireClient } from "@/types/clients/esquire";
import ReservationLoginData, {
  IReservationLoginData
} from "@/types/clients/esquire/data/general/reservation-login-data";
import type { EntryAttribution } from "@/stores/session/entry-attribution";

export default class GetRoutesAndCrm {
  public constructor(private client: EsquireClient) {}

  public async send(
    signature: string,
    expires: number,
    crmId: number,
    attribution?: EntryAttribution
  ): Promise<ReservationLoginData> {
    const url = new URL(
      `${process.env.VUE_APP_ESQUIRE_HOST}/api/v1/guest-app/guest-admin/${encodeURIComponent(crmId)}`
    );

    url.searchParams.set("expires", String(expires));
    url.searchParams.set("signature", signature);
    url.searchParams.set("type", "reservation-login");

    if (attribution) {
      if (attribution.buildingId) {
        url.searchParams.set("building_id", attribution.buildingId);
      }

      url.searchParams.set("entry_point", attribution.entryPoint);
      url.searchParams.set("entry_session_id", attribution.entrySessionId);
    }

    const response = await this.client.fetch(() => url, {
      method: "GET"
    });

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
    }

    const result = await response.json() as IReservationLoginData;

    return new ReservationLoginData(result);
  }
}
